import { getDefaultExportFromCjs as r } from "./index.es152.js";
import { __require as i } from "./index.es236.js";
var o = i();
const p = /* @__PURE__ */ r(o);
export {
  p as default
};
//# sourceMappingURL=index.es206.js.map
